export default __webpack_public_path__ + "static/media/closeIcon.843985eb.svg";